export const REGISTER_INIT_REQUEST = 'REGISTER_INIT_REQUEST';
export const REGISTER_INIT_SUCCESS = 'REGISTER_INIT_SUCCESS';
export const REGISTER_INIT_FAILURE = 'REGISTER_INIT_FAILURE';
export const REGISTER_VERIFY_REQUEST = 'REGISTER_VERIFY_REQUEST';
export const REGISTER_VERIFY_SUCCESS = 'REGISTER_VERIFY_SUCCESS';
export const REGISTER_VERIFY_FAILURE = 'REGISTER_VERIFY_FAILURE';
export const REGISTER_CREATE_USER_REQUEST = 'REGISTER_CREATE_USER_REQUEST';
export const REGISTER_CREATE_USER_SUCCESS = 'REGISTER_CREATE_USER_SUCCESS';
export const REGISTER_CREATE_USER_FAILURE = 'REGISTER_CREATE_USER_FAILURE';
export const REGISTER_SET_ERROR = 'REGISTER_SET_ERROR';
